/**
 * Фабрика плагинов ModelerX6: регистрация и жизненный цикл (setup/teardown).
 * Каждый плагин — отдельный файл с методом init(modeler, context) => cleanup.
 *
 * @typedef {Object} PluginContext
 * @property {import('@antv/x6').Graph} graph
 * @property {(payload: { patches: Array }) => void} onPatch
 * @property {(payload: object) => void} [onLive]
 * @property {(payload: object) => void} [onLock]
 * @property {number} viewIndex
 *
 * @typedef {Object} Plugin
 * @property {(modeler: import('../ModelerX6').default, context: PluginContext) => (() => void)} init
 */

export default class PluginFactory {
	/**
	 * @param {import('../ModelerX6').default} modeler
	 */
	constructor(modeler) {
		this._modeler = modeler;
		/** @type {Plugin[]} */
		this._plugins = [];
		/** @type {Array<() => void>} */
		this._cleanups = [];
	}

	/**
	 * Регистрирует плагин (порядок вызова init — порядок регистрации).
	 * @param {Plugin} plugin
	 */
	register(plugin) {
		if (plugin && typeof plugin.init === 'function') {
			this._plugins.push(plugin);
		}
	}

	/**
	 * Запускает все плагины, сохраняет cleanup-функции.
	 * @param {PluginContext} context
	 * @returns {() => void} общая отписка
	 */
	setup(context) {
		this.teardown();
		this._cleanups = this._plugins
			.map(p => p.init(this._modeler, context))
			.filter(fn => typeof fn === 'function');
		return () => this.teardown();
	}

	/**
	 * Вызывает все зарегистрированные cleanup-функции и очищает список.
	 */
	teardown() {
		this._cleanups.forEach(fn => fn());
		this._cleanups = [];
	}
}
